module.exports = __webpack_public_path__ + "static/media/ic_question.1e7c4448.svg";